/**
 * @fileoverview Custom hook for determining PointClickCare integration status for a facility.
 */

import {PccIntegrationStatus} from "../services/PccService";

import {extractPccIntegrationStatusOfFacility} from "../utils/helpers/extractPccIntegrationStatusOfFacility";
import {Facilities} from "../models/types/AdmissionForm";

/**
 * Custom hook that determines the PointClickCare integration status for a specific facility.
 * Extracts the PCC status from the facilities data and returns a boolean indicating if PCC is enabled.
 *
 * @param {Facilities} facilities The facilities data containing PCC integration status.
 * @param {string} facilityId The ID of the facility to check.
 * @returns {Object} Object containing the PCC enabled status.
 * @returns {boolean|undefined} returns.isPccEnabled Whether PCC is enabled for the facility, or undefined if status is unknown.
 */
export const usePointClickCareStatus = (
  facilities: Facilities,
  facilityId: string,
) => {
  const pccStatus = extractPccIntegrationStatusOfFacility(
    facilities,
    facilityId,
  );

  return {
    isPccEnabled:
      pccStatus === PccIntegrationStatus.PccTurnedOn
        ? true
        : pccStatus === PccIntegrationStatus.PccTurnedOff
        ? false
        : undefined,
  };
};
